module.exports = __webpack_public_path__ + "img/13.3dbbe754.jpg";